import qs from 'qs';
import client from '@/api/base';

export default {
// notifications
  async getNewNotificationsCount() {
    const response = await client.get('notification/');
    return response;
  },

  async getNotifications(params) {
    const response = await client.patch(`notification/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async markAsReadNotification(id) {
    const response = await client.patch(`notification/update/${id}/`);
    return response;
  },

  async markAllAsReadNotification() {
    const response = await client.patch('notification/update/');
    return response;
  },
};
